/**
 * @license Copyright (c) Microsoft Corporation.  All rights reserved.
 */
import { areNonessentialCookiesDisabled } from "./CookieConsentUtils";
export var createFormSubmissionCookie = function (formSubmissionId, logger) {
    if (!formSubmissionId) {
        logger.log("No formSubmissionId available. Skipping creation of formSubmissionId cookie.");
        return;
    }
    if (areNonessentialCookiesDisabled()) {
        logger.log("Nonessential cookies are disabled. Skipping creation of formSubmissionId cookie.");
        return;
    }
    var cookieString = "msdynmkt_formsubmissionid=".concat(formSubmissionId, ";path=/;max-age=31536000");
    document.cookie = cookieString;
};
